import React, { FC, useEffect, useState } from 'react';
import './index.scss';
import AndrewImage from '../../images/andrew.jpg';
import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image';
import Modal from '../modal';
import { graphql, useStaticQuery } from 'gatsby';
import { Analytics, logEvent } from 'firebase/analytics';
import { analytics } from '../../utilities/firebase';

export interface TeamMember {
  id: string;
  name: string;
  services: string[];
  squireLink: string;
  giftCardLink?: string;
  instagram?: string;
  image?: any;
}

const team = [
  {
    id: 'andrew',
    name: 'Andrew',
    services: [
      'haircut',
      'beard grooming',
      `senior's haircut`,
      `kid's cut (12 & younger)`,
    ],
    instagram: 'barber_andreww',
    squireLink:
      'https://getsquire.com/booking/book/onefam-glendale-heights/barber/andrew-f-2/services',
    giftCardLink:
      'https://getsquire.com/booking/gift-card/onefam-glendale-heights/barber/andrew-f-2',
  } as TeamMember,
  {
    id: 'bernie',
    name: 'Bernie',
    services: ['haircut', 'beard grooming', "kid's cut (12 & younger)"],
    instagram: undefined,
    squireLink:
      'https://getsquire.com/booking/book/onefam-glendale-heights/barber/bernie-g-6/services',
    giftCardLink:
      'https://getsquire.com/booking/gift-card/onefam-glendale-heights/barber/bernie-g-6',
  } as TeamMember,
  {
    id: 'chong',
    name: 'Chong',
    services: [
      'haircut + beard grooming',
      `kid's cut (12 & younger)`,
      `teen's cut (Ages 13-17)`,
      `senior's cut (60+)`,
    ],
    instagram: 'boyz2beardz',
    squireLink:
      'https://getsquire.com/booking/book/onefam-glendale-heights/barber/chong-k/services',
    giftCardLink:
      'https://getsquire.com/booking/gift-card/onefam-glendale-heights/barber/chong-k',
  } as TeamMember,
  {
    id: 'gianna',
    name: 'Gianna',
    services: [
      'haircut + beard grooming',
      `women's haircut`,
      'hair color',
      'hair styling',
      `kid's cut (12 & younger)`,
      `senior's cut (60+)`,
      '+ more',
    ],
    instagram: 'spatola_gianna',
    squireLink:
      'https://getsquire.com/booking/book/onefam-glendale-heights/barber/gianna-s/services',
    giftCardLink:
      'https://getsquire.com/booking/gift-card/onefam-glendale-heights/barber/gianna-s',
  } as TeamMember,
  {
    id: 'john',
    name: 'John',
    services: ['haircut', 'beard grooming', , `senior's cut (60+)`],
    instagram: 'j1hn.q___',
    squireLink:
      'https://getsquire.com/booking/book/onefam-glendale-heights/barber/john-q-1/services',
    giftCardLink:
      'https://getsquire.com/booking/gift-card/onefam-glendale-heights/barber/john-q-1',
  } as TeamMember,
  {
    id: 'mavi',
    name: 'Mavi',
    services: [
      'haircut + beard grooming',
      `women's haircut`,
      'hair color',
      'facial',
      `kid's cut (12 & younger)`,
      `senior's cut (60+)`,
      '+ more',
    ],
    instagram: 'mavirubiopro',
    squireLink:
      'https://getsquire.com/booking/book/onefam-glendale-heights/barber/mavi-r/services',
    giftCardLink:
      'https://getsquire.com/booking/gift-card/onefam-glendale-heights/barber/mavi-r',
  } as TeamMember,
  {
    id: 'rigo',
    name: 'Rigo',
    services: [
      'haircut',
      'beard grooming',
      `senior's haircut`,
      `kid's cut (12 & younger)`,
    ],
    instagram: 'flocks_13',
    squireLink:
      'https://getsquire.com/booking/book/onefam-glendale-heights/barber/rigo-de-anda/services',
    giftCardLink:
      'https://getsquire.com/booking/gift-card/onefam-glendale-heights/barber/rigo-de-anda',
  } as TeamMember,
];

export interface TeamProps {}

const Team = React.forwardRef<HTMLDivElement, TeamProps>(function Team(
  {},
  ref
) {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { relativeDirectory: { eq: "team" } }) {
        edges {
          node {
            id
            relativePath
            name
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  `);
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);
  const [memberModal, setMemberModal] = useState<TeamMember | undefined>(
    undefined
  );

  useEffect(() => {
    if (data.allFile.edges) {
      const updatedTeam = team.map((member) => {
        const imageNode = data.allFile.edges.find(
          (image: any) => image.node.name === member.id
        ).node;
        const image = getImage(imageNode);
        return { ...member, image };
      });
      setTeamMembers(updatedTeam);
    }
  }, [data.allFile.edges]);

  const openModal = (member: TeamMember) => {
    setMemberModal(member);
  };

  const closeModal = () => {
    setMemberModal(undefined);
  };

  const onBookClick = (link: string, artistName: string) => {
    const firebaseAnalytics = analytics();
    if (firebaseAnalytics) {
      logEvent(firebaseAnalytics, 'book_appointment', { name: artistName });
    }
    location.href = link;
  };

  const onGiftCardClick = (artistName: string) => {
    const firebaseAnalytics = analytics();
    if (firebaseAnalytics) {
      logEvent(firebaseAnalytics, 'purchase_gift_card', { name: artistName });
    }
  };

  return (
    <section id='team' key='team-section' ref={ref}>
      <div className='content-container'>
        <div className='title-container'>
          <h2
            data-sal='slide-up'
            data-sal-duration='500'
            data-sal-easing='ease-in-out'
          >
            the fam
          </h2>
        </div>
        <div className='team-member-container'>
          {teamMembers.map((member) => (
            <div
              className='team-member'
              key={`team-member-${member.id}`}
              onClick={() => openModal(member)}
            >
              <div className='hover'>
                <span>{member.name}</span>
              </div>
              <GatsbyImage
                image={member.image}
                alt={`${member.id}-image`}
                className='team-member-image'
              />
            </div>
          ))}
        </div>
      </div>
      {memberModal && (
        <Modal isOpen={memberModal ? true : false} onClose={closeModal}>
          <div className='team-modal-member-image'>
            <GatsbyImage
              image={memberModal.image}
              alt={`${memberModal.id}-modal-image`}
              className='modal-image'
            />
          </div>
          <div className='team-modal-member-details'>
            <h3>
              meet <span>{memberModal.name}</span>
            </h3>
            <span className='modal-sub-title'>Artist's Services:</span>
            <ul>
              {memberModal.services.map((service, index) => (
                <li key={`${memberModal.id}service-${index}`}>{service}</li>
              ))}
            </ul>
            {memberModal.instagram && (
              <>
                <span className='modal-sub-title'>Social:</span>
                <ul className='social-container'>
                  <li className='social'>
                    <a
                      href={`https://www.instagram.com/${memberModal.instagram}/`}
                      target='_blank'
                    >
                      <div className='ig-logo'>
                        <StaticImage
                          objectFit='contain'
                          className='instagram-logo'
                          height={16}
                          layout='fixed'
                          src='../../images/instagram-logo.png'
                          alt='instagram Logo'
                          placeholder='none'
                        />
                      </div>
                      {memberModal.instagram}
                    </a>
                  </li>
                </ul>
              </>
            )}
            <button
              className='outline-black'
              onClick={() =>
                onBookClick(memberModal.squireLink, memberModal.id)
              }
            >
              book with&nbsp;
              <span>{memberModal.name}</span>
            </button>
            <a
              className='gift-card-link'
              id={`${memberModal.id}-gift-card`}
              href={memberModal.giftCardLink}
              onClick={() => onGiftCardClick(memberModal.id)}
            >
              purchase a gift card
            </a>
          </div>
        </Modal>
      )}
    </section>
  );
});

export default Team;
